import createIcon from '../../createIcon';

/**
 * @component @name SwipeUpAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgNi44M0wxNC41OSA4LjQyTDE2IDdMMTIgM0w4IDdMOS40MSA4LjQxTDExIDYuODNWMTEuMUM4LjcyIDExLjU2IDcgMTMuNTggNyAxNkM3IDE4Ljc2IDkuMjQgMjEgMTIgMjFDMTQuNzYgMjEgMTcgMTguNzYgMTcgMTZDMTcgMTMuNTggMTUuMjggMTEuNTYgMTMgMTEuMVY2LjgzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwipeUpAlt = createIcon('SwipeUpAlt', [
  [
    'path',
    {
      d: 'M13 6.83L14.59 8.42L16 7L12 3L8 7L9.41 8.41L11 6.83V11.1C8.72 11.56 7 13.58 7 16C7 18.76 9.24 21 12 21C14.76 21 17 18.76 17 16C17 13.58 15.28 11.56 13 11.1V6.83Z',
      key: '8hpfj4',
    },
  ],
]);

export default SwipeUpAlt;
